module.exports = __webpack_public_path__ + "img/file_image.68d06cc0.svg";